import React from "react";

const DatabaseSearchContext = React.createContext();

export default DatabaseSearchContext;
